import { Navigate } from "react-router-dom";
import { navigationGroups } from "@/surfaces/standalone/navigation/navigation-model";
import { useVisibleNavigationGroups } from "@/surfaces/standalone/navigation/use-navigation";

/**
 * 工作台首页落点。默认去「全部工单」，但只有报表权限、没有工单权限的人
 * 会被守卫顶到 403，所以这里改成落到第一个当前可见、且有路由的菜单项。
 */
export function WorkspaceIndexRedirect() {
  const groups = useVisibleNavigationGroups(navigationGroups);
  const target = groups.flatMap((group) => group.items).find((item) => item.href)?.href;

  return <Navigate replace to={target ?? "/tickets/all"} />;
}
